export enum INFO_CATEGORY_MASTER_DATA {
  PRODUCT_INCOME = 'PRODUCT_INCOME',
  EXPORT_INCOME = 'EXPORT_INCOME',
  OTHER_INCOME = 'OTHER_INCOME',
  PROVINCES = 'PROVINCES',
  GOAL_BUSINESS_PLAN = 'GOAL_BUSINESS_PLAN',
  GOAL_COST_PLAN = 'GOAL_COST_PLAN',
  GOAL_INVESTMENT_PLAN = 'GOAL_INVESTMENT_PLAN',
  GOAL_DEBT_PLAN = 'GOAL_DEBT_PLAN',
  GH_GAS_SCOPE = 'GH_GAS_SCOPE',
  CERTIFICATE_TGO = 'CERTIFICATE_TGO',
  SBTI_GH_GAS_TARGET = 'SBTI_GH_GAS_TARGET',
  DEPT_CARBON_NEUTRAL = 'DEPT_CARBON_NEUTRAL',
  GHG_VERIFIER = 'GHG_VERIFIER',
  DIRECTOR_EVALUATION_TYPE = 'DIRECTOR_EVALUATION_TYPE',
  SUB_COMMITTEE_ROLE = 'SUB_COMMITTEE_ROLE',
}
